<template>
  <div v-if="activated" >
    <div >
      <h3>
        RAM
      </h3>
      <div class="text-right">
        <small id="mem_text">
          {{Math.round(status.maxmem/status.mem)}} % ({{Math.round(status.mem/(1024*1024))}} MB
          von {{Math.round(status.maxmem/(1024*1024*1024))}} GB)
        </small>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-success"
             :style="mem"
             id="mem_percent">
        </div>
      </div>
    </div>
    <hr>
    <div>
      <h3>
        CPU
      </h3>
      <div class="text-right">
        <small id="cpu_text">
          {{ Math.round(status.cpu *10000)/100 }} %
          von {{status.cpus}} Kerne
        </small>
      </div>
      <div class="progress">
        <div class="progress-bar progress-bar-success"
             :style="cpu"
             id="cpu_percent">
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {Vserver} from "@/store/models/vserver/vserver";
  export default {
      name: "luma-cpu-ram-live-line-chart",
      props:{
          activated:Boolean
      },
      data:()=>({
          timer:null
      }),
      computed:{
          vid(){
              return this.$route.params.id
          },
          status(){
              // if(!this.refreshC) return
              if(!Vserver.find(this.vid).status ) Vserver.fetchStatus(this.vid)
              return Vserver.find(this.vid).status
          },
          mem(){
              return {
                  width: Math.round(this.status.maxmem/this.status.mem)+'%'
              }
          },
          cpu(){
              return {
                  width: Math.round(this.status.cpu *10000)/100+'%'
              }
          }

          // refreshC(){
          //     this.activated ? this.timer = setInterval(this.refresh,3000) : clearInterval(this.timer)
          //     return this.activated
          // }
      },
      // methods:{
      //     refresh(){
      //         if(!this.activated) return clearInterval(this.timer)
      //         return Vserver.fetchStatus(this.vid)
      //     },
      //
      // },
      // beforeDestroy() {
      //     clearInterval(this.timer)
      // }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/vserver_charts/luma-cpu-ram-live-line-chart.vue